import  { useEffect, useState } from "react";
import Api from "./Api";
import { Redirect } from "react-router-dom";
const useFetchData = (url) => {

    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        setIsLoading(true)
        Api.get(url)
            .then(function (response) {  
                setResponse(response);
                setIsLoading(false);

            })
            .catch(function (error) {
                // handle error
                setError(error);
               if(error.response.status===401){
                window.sessionStorage.clear();
                localStorage.clear();
                return <Redirect to="/" push />;
               }
            })
            .then(function () {
                // always executed
            })
        
    }, []);
    return { response, error, isLoading };
};

export default useFetchData;